import { hover } from "@testing-library/user-event/dist/hover";
import React from "react";
import useHandleBoxTypes from "../hooks/useHandleBoxTypes";
import useHover from "../hooks/useHover";
import useSizePercentage from "../hooks/useSizePercentage";
import SmallItemHolder from "../misc/elements/SmallItemHolder";
import MainStore from "../stores/MainStore";

const DetailedCenter = ({
  shortDescription,
  type,
  image,
  categories,
  keywords,
  things,
}) => {
  const sizePercentage = useSizePercentage();
  const { player } = MainStore();
  const { getBoxType } = useHandleBoxTypes();
  const boxType = getBoxType(type);
  return (
    <div
      className="divColumn"
      style={{ width: "35%", height: "100%", marginTop: "15px" }}
    >
      <div
        className="textBold"
        style={{ color: boxType.colors.text, fontSize: "25px" }}
      >
        {shortDescription}
      </div>
      <div
        className="divColumn"
        style={{ flex: 1, width: "100%", justifyContent: "center" }}
      >
        <img
          src={image}
          style={{
            objectFit: "contain",
            maxWidth: "100%",
            height: `${sizePercentage.height}%`,
          }}
        />
      </div>
      <div
        className="divColumn"
        style={{
          marginBottom: "15px",
          width: "100%",
          justifyContent: "space-around",
          minHeight: "80px",
          borderRadius: ".5rem/.5rem",
          backgroundColor: boxType.colors.secondary,
          border: "#5099b0",
          paddingTop: "5px",
          paddingBottom: "5px",
        }}
      >
        <BottomBar type={"Categories"} list={categories} />
        <div
          style={{
            borderBottom: "2px solid grey",
            width: "90%",
            marginTop: "2px",
            marginBottom: "2px",
          }}
        />
        <BottomBar type={"Keywords"} list={keywords} />
        <div
          style={{
            borderBottom: "2px solid grey",
            width: "90%",
            marginTop: "2px",
            marginBottom: "2px",
          }}
        />
        <BottomBar type={"Things"} list={things} />
      </div>
    </div>
  );
};

const BottomBar = ({ type, list }) => {
  const typeHover = useHover();
  return (
    <div
      className="divRow"
      style={{
        width: "100%",
        marginLeft: "5px",
      }}
    >
      <div
        {...typeHover.divProps}
        className="textBold"
        style={{
          cursor: "pointer",
          fontStyle: "italic",
          opacity: typeHover.hover ? 1 : 0.8,
          color: "white",
          padding: "5px",
          backgroundColor: "#2f2f2f",
          width: "80px",
          borderRadius: "5px",
          textAlign: "center",
        }}
      >
        {type}
      </div>
      <div
        className="divRow"
        style={{ flex: 1, justifyContent: "center", overflow: "auto" }}
      >
        {list.map((item) => (
          <SmallItemHolder item={item} key={item} />
        ))}
      </div>
    </div>
  );
};

export default DetailedCenter;
